"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const _ = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const getLargestIndustry = (concentrationReceivables) => {
    return (0, remeda_1.pipe)(concentrationReceivables, (0, remeda_1.groupBy)((receivable) => receivable.baseFields.cb_scores_fields_2_sic_2
        ? `${receivable.baseFields.cb_scores_fields_2_sic_2}`
        : 'undefined'), (0, remeda_1.mapValues)((receivables, sic2new) => {
        const totalEligibleExposure = _.sumBy(receivables, (receivable) => receivable.eligibilityFields.eligibleExposure);
        return {
            sic2new,
            totalEligibleExposure,
        };
    }), remeda_1.values, (0, remeda_1.sortBy)([
        (el) => el.totalEligibleExposure,
        'desc',
    ]), (0, remeda_1.first)());
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'tripActionsGoldmanSachs1.anySingleObligor',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit maxSingleObligor`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const standardBorrowingBaseReductions = _.map(concentrationReceivables, (receivable) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: [receivable],
                    concentrationLimitValueType,
                });
            });
            // accumulate all breaches into a single standard borrowing base reduction
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                const _result = { ...result };
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!_result[finleyReceivableId]) {
                        _result[finleyReceivableId] = 0;
                    }
                    _result[finleyReceivableId] += kickout;
                    return true;
                });
                return _result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    {
        method: 'tripActionsGoldmanSachs1.customComputerProgrammingSoftware',
        pointerImplementation: ({ concentrationReceivables, valueConfig }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit customComputerProgrammingSoftware`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const largestIndustry = getLargestIndustry(concentrationReceivables);
            // concentration limit only in effect if largest industry is business services (73)
            if (!largestIndustry || largestIndustry.sic2new !== '73') {
                return {
                    kickouts: {},
                    calculations: {
                        concentrationLimit,
                        concentrationAmount: 0,
                        concentration: 0,
                    },
                };
            }
            const businessServices = _.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic_2 === 73);
            const businessServicesTotalEligibleExposure = _.sumBy(businessServices, (receivable) => receivable.eligibilityFields.eligibleExposure);
            const customComputingProgrammingSoftware = _.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic === 7371 &&
                !receivable.baseFields.excluded_obligors);
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit,
                totalConcentrationExposure: businessServicesTotalEligibleExposure,
                concentrationReceivables: customComputingProgrammingSoftware,
                concentrationLimitValueType,
            });
        },
    },
    {
        method: 'tripActionsGoldmanSachs1.prePackagedSoftware',
        pointerImplementation: ({ concentrationReceivables, valueConfig }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit prePackagedSoftware`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const largestIndustry = getLargestIndustry(concentrationReceivables);
            // concentration limit only in effect if largest industry is business services (73)
            if (!largestIndustry || largestIndustry.sic2new !== '73') {
                return {
                    kickouts: {},
                    calculations: {
                        concentrationLimit,
                        concentrationAmount: 0,
                        concentration: 0,
                    },
                };
            }
            const businessServices = _.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic_2 === 73);
            const businessServicesTotalEligibleExposure = _.sumBy(businessServices, (receivable) => receivable.eligibilityFields.eligibleExposure);
            const prePackagedSoftware = _.filter(concentrationReceivables, (receivable) => receivable.baseFields.cb_scores_fields_2_sic === 7372 &&
                !receivable.baseFields.excluded_obligors);
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit,
                totalConcentrationExposure: businessServicesTotalEligibleExposure,
                concentrationReceivables: prePackagedSoftware,
                concentrationLimitValueType,
            });
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map